import {
  InfoLink,
  InfoParagraph,
  InfoSection,
  PublicInfoShell
} from "@/components/PublicInfoShell";

export default function DeleteAccountRoute() {
  return (
    <PublicInfoShell
      eyebrow="Recital Master account and data"
      title="Delete your account"
      intro="Recital Master is the app and service provided by the Recital Master developer. You can permanently delete your family account and its associated personal information."
    >
      <InfoSection title="Delete in the app">
        <InfoParagraph>While signed in, open Account, select Delete account at the bottom of the screen, and confirm. The app cancels any active renewal, permanently deletes the account and associated app data, and signs you out.</InfoParagraph>
      </InfoSection>

      <InfoSection title="Request deletion after uninstalling">
        <InfoParagraph>Email <InfoLink href="mailto:recitalmaster@gmail.com?subject=Account%20deletion%20request">recitalmaster@gmail.com</InfoLink> from the email address connected to the account with the subject “Account deletion request.” This web-based request route remains available if you no longer have the app. We will verify control of the account before completing the request.</InfoParagraph>
      </InfoSection>

      <InfoSection title="What deletion covers">
        <InfoParagraph>Deletion removes the Firebase sign-in account, family profile and recital grants, registered devices and device history, playback sessions and viewing telemetry, saved dancers, playback progress, sign-in request records, expiry notices, and other app data linked to the account.</InfoParagraph>
        <InfoParagraph>Deletion removes the ability to sign in and watch content through that account. It does not delete the recital production itself or footage maintained for other authorized families.</InfoParagraph>
      </InfoSection>

      <InfoSection title="What is retained">
        <InfoParagraph>Stripe customer, canceled-subscription, invoice, and payment records are retained only for transaction, accounting, and tax obligations. Canadian tax records are generally kept for six years from the end of the tax year they relate to, or longer only when legally required.</InfoParagraph>
        <InfoParagraph>A content-free, pseudonymous deletion audit is retained for 30 days to support retry and operator verification, then automatically purged. Standard server logs and short-lived, hashed abuse-prevention records expire on their own schedules. Recital footage is shared production media rather than account data and remains available to other authorized families.</InfoParagraph>
      </InfoSection>

      <InfoSection title="Need help first?">
        <InfoParagraph>If you only need to remove a device, change a saved dancer, or resolve access, contact <InfoLink href="/support">support</InfoLink> instead of deleting the entire account.</InfoParagraph>
      </InfoSection>
    </PublicInfoShell>
  );
}
